import { Link } from "react-router-dom";
import { LEGAL_DOCS } from "../data/legal";
import { Seo } from "../components/Seo";
import { MaskedLine, Reveal } from "../components/Reveal";

export default function LegalPage({ doc }) {
  const d = LEGAL_DOCS[doc];

  return (
    <>
      <Seo title={d.metaTitle} description={d.metaDescription} path={d.path} />

      <section className="mx-auto max-w-4xl px-5 pb-24 pt-36 md:px-8 md:pt-44" data-testid={`${doc}-page`}>
        <MaskedLine delay={0.1}>
          <span className="eyebrow">{d.eyebrow}</span>
        </MaskedLine>
        <h1 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tighter md:text-6xl">
          <MaskedLine delay={0.25}>
            <span className="text-metallic">{d.h1}</span>
          </MaskedLine>
        </h1>
        <MaskedLine delay={0.4}>
          <p className="mt-4 font-display text-xs font-bold uppercase tracking-[0.25em] text-[#A8B4C2]">{d.updated}</p>
        </MaskedLine>
        <MaskedLine delay={0.5}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#C9D2DE]">{d.intro}</p>
        </MaskedLine>

        <div className="mt-16 space-y-12">
          {d.sections.map((s, i) => (
            <Reveal key={s.h} delay={Math.min(i * 0.04, 0.3)}>
              <div className="border-t border-white/10 pt-8" data-testid={`${doc}-section-${i}`}>
                <h2 className="font-display text-xl font-bold tracking-tight text-white">{s.h}</h2>
                {s.p.map((para, j) => (
                  <p key={j} className="mt-4 text-sm leading-relaxed text-[#C9D2DE]">
                    {para}
                  </p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-16 border-t border-white/10 pt-8 text-sm text-[#A8B4C2]">
            {doc === "terms" ? (
              <>
                Also see our{" "}
                <Link to="/privacy" className="text-brand hover:underline" data-testid="terms-to-privacy-link">
                  Privacy Policy
                </Link>
                .
              </>
            ) : (
              <>
                Also see our{" "}
                <Link to="/terms" className="text-brand hover:underline" data-testid="privacy-to-terms-link">
                  Terms of Service
                </Link>
                .
              </>
            )}
          </p>
        </Reveal>
      </section>
    </>
  );
}
